class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') this.close();
    });

    const overlay = this.querySelector('#CartDrawer-Overlay');

    if (overlay) {
      overlay.addEventListener('click', this.close.bind(this));
    }

    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');

    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');

    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) {
      this.setActiveElement(triggeredBy);
    }

    const cartDrawerNote = this.querySelector(
      '[id^="Details-"] summary'
    );

    if (
      cartDrawerNote &&
      !cartDrawerNote.hasAttribute('role')
    ) {
      this.setSummaryAccessibility(cartDrawerNote);
    }

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn =
          this.classList.contains('is-empty')
            ? this.querySelector('.drawer__inner-empty')
            : document.getElementById('CartDrawer');

        const focusElement =
          this.querySelector('.drawer__inner') ||
          this.querySelector('.drawer__close');

        if (containerToTrapFocusOn && focusElement) {
          trapFocus(
            containerToTrapFocusOn,
            focusElement
          );
        }
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');

    removeTrapFocus(this.activeElement);

    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute(
      'aria-expanded',
      'false'
    );

    if (
      cartDrawerNote.nextElementSibling &&
      cartDrawerNote.nextElementSibling.getAttribute('id')
    ) {
      cartDrawerNote.setAttribute(
        'aria-controls',
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener(
      'click',
      (event) => {
        event.currentTarget.setAttribute(
          'aria-expanded',
          !event.currentTarget
            .closest('details')
            .hasAttribute('open')
        );
      }
    );

    cartDrawerNote.parentElement.addEventListener(
      'keyup',
      onKeyUpEscape
    );
  }

  updateCartCountBubble(sectionHtml) {
    if (!sectionHtml) return;

    const parsedHTML = new DOMParser().parseFromString(
      sectionHtml,
      'text/html'
    );

    const newBubble =
      parsedHTML.querySelector(
        '#cart-icon-bubble .cart-count-bubble'
      ) ||
      parsedHTML.querySelector('.cart-count-bubble');
    const targets = [
      document.querySelector('#cart-icon-bubble'),
      document.querySelector(
        '#cart-icon-bubble-mobile'
      ),
    ].filter(Boolean);

    targets.forEach((target) => {
      const currentBubble =
        target.querySelector('.cart-count-bubble');

      if (!newBubble) {
        if (currentBubble) {
          currentBubble.remove();
        }

        return;
      }

      const clonedBubble =
        newBubble.cloneNode(true);

      if (currentBubble) {
        currentBubble.replaceWith(clonedBubble);
      } else {
        target.appendChild(clonedBubble);
      }
    });
  }

  renderContents(parsedState) {
    const drawerInner =
      this.querySelector('.drawer__inner');

    if (
      drawerInner &&
      drawerInner.classList.contains('is-empty')
    ) {
      drawerInner.classList.remove('is-empty');
    }

    this.classList.remove('is-empty');

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      if (section.id === 'cart-icon-bubble') {
        this.updateCartCountBubble(
          parsedState.sections[section.id]
        );

        return;
      }

      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;

      const newHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );

      if (newHTML !== null) {
        sectionElement.innerHTML = newHTML;
      }
    });

    setTimeout(() => {
      const overlay =
        this.querySelector('#CartDrawer-Overlay');

      if (overlay) {
        overlay.addEventListener(
          'click',
          this.close.bind(this)
        );
      }

      this.open();
    });
  }

  getSectionInnerHTML(
    html,
    selector = '.shopify-section'
  ) {
    if (!html) return null;

    const parsedHTML =
      new DOMParser().parseFromString(
        html,
        'text/html'
      );

    const element =
      parsedHTML.querySelector(selector);

    return element
      ? element.innerHTML
      : null;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(
    html,
    selector = '.shopify-section'
  ) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define(
  'cart-drawer',
  CartDrawer
);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define(
  'cart-drawer-items',
  CartDrawerItems
);